import React from 'react';
import { TrendingUp, Clock } from 'lucide-react';

const Dashboard: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-[80vh] bg-slate-50">
    <div className="flex flex-col items-center">
      <div className="w-28 h-28 bg-slate-100 rounded-full flex items-center justify-center mb-8">
        <TrendingUp className="w-12 h-12 text-slate-400" />
      </div>
      <h2 className="font-bold text-2xl md:text-3xl text-slate-900 mb-4" style={{ fontFamily: 'Afacad, sans-serif' }}>
        Dashboard Coming Soon
      </h2>
      <p className="text-slate-400 text-base md:text-lg mb-8 text-center max-w-xl leading-relaxed" style={{ fontFamily: 'Afacad, sans-serif' }}>
        We&apos;re working hard to bring you an amazing dashboard experience.<br />
        Check back soon for analytics, reports, and insights.
      </p>
      <div className="mt-2">
        <div className="inline-flex items-center px-6 py-2 bg-slate-100 text-slate-500 rounded-full text-sm font-medium shadow-sm" style={{ fontFamily: 'Afacad, sans-serif' }}>
          <Clock className="mr-2 w-5 h-5" />
          <span className="font-medium">Expected Launch: <span className="text-blue-700 font-semibold">Q1 2026</span></span>
        </div>
      </div>
    </div>
  </div>
);

export default Dashboard; 